/**
 * @generated SignedSource<<b9f40eb60c0eb165195e032d32a8fcbd>>
 * @relayHash 5af6060674c3730fad12a25ae8e02d51
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5bdfe259f652ed9a7817ff35a6a983c26b71153be1b028a4a17c1bf9739056a8

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RemoveEventAttendanceInput = {
  clientMutationId?: string | null | undefined;
  eventId: string;
  userId?: string | null | undefined;
};
export type EventAttendButtonSingleRemoveAttendanceMutation$variables = {
  input: RemoveEventAttendanceInput;
};
export type EventAttendButtonSingleRemoveAttendanceMutation$data = {
  readonly removeEventAttendance: {
    readonly event: {
      readonly " $fragmentSpreads": FragmentRefs<"EventItemNew_event" | "EventScreenAttendeesDialogContent_event" | "EventScreenNewDesktop_event" | "EventScreenNewMobile_event">;
    } | null | undefined;
  } | null | undefined;
};
export type EventAttendButtonSingleRemoveAttendanceMutation = {
  response: EventAttendButtonSingleRemoveAttendanceMutation$data;
  variables: EventAttendButtonSingleRemoveAttendanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v8 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v9 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v10 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v11 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipLevel",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMe",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v18 = {
  "kind": "Literal",
  "name": "fo",
  "value": "auto"
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v8/*: any*/),
            (v9/*: any*/),
            (v18/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"auto\",\"h\":100,\"w\":100})"
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v8/*: any*/),
        (v18/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":100,\"w\":100})"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v22 = {
  "kind": "Literal",
  "name": "filter",
  "value": {
    "status": {
      "in": [
        "ATTENDING_IN_PERSON",
        "ATTENDING_VIRTUAL",
        "WAITING_IN_PERSON",
        "WAITING_VIRTUAL"
      ]
    }
  }
},
v23 = [
  (v22/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v25 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v4/*: any*/),
  (v17/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v5/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v27 = [
  (v24/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v25/*: any*/),
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      (v26/*: any*/)
    ],
    "storageKey": null
  }
],
v28 = [
  (v24/*: any*/)
],
v29 = {
  "kind": "Literal",
  "name": "filter",
  "value": {
    "status": {
      "in": [
        "WAITING_IN_PERSON",
        "WAITING_VIRTUAL"
      ]
    }
  }
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterFirstName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterLastName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "presenter",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateProvinceRegionCode",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipPostalCode",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "geojson",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v42 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "status": "ATTENDING_IN_PERSON"
    }
  },
  (v41/*: any*/)
],
v43 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventAttendeesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v26/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "EventAttendee",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v4/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v24/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v44 = [
  "condition"
],
v45 = [
  (v29/*: any*/),
  (v41/*: any*/)
],
v46 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "status": "ATTENDING_VIRTUAL"
    }
  },
  (v41/*: any*/)
],
v47 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "status": "NOT_ATTENDING"
    }
  },
  (v41/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventAttendButtonSingleRemoveAttendanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveEventAttendancePayload",
        "kind": "LinkedField",
        "name": "removeEventAttendance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventItemNew_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenNewMobile_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenNewDesktop_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventScreenAttendeesDialogContent_event"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventAttendButtonSingleRemoveAttendanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveEventAttendancePayload",
        "kind": "LinkedField",
        "name": "removeEventAttendance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startAt",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasExternalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasVenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "coverPhoto",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": "mobileTransformUrl",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "w": 576
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":576})"
                  },
                  {
                    "alias": "desktopTransformUrl",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "w": 200
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":200})"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "w": 368
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":368})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "eventOwner",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GuildMembership",
                        "kind": "LinkedField",
                        "name": "myMembership",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v7/*: any*/),
                      (v16/*: any*/),
                      (v4/*: any*/),
                      (v17/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "attendeesByRelevance",
                "args": (v23/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v27/*: any*/),
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
              },
              {
                "alias": "attendingCount",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": {
                        "in": [
                          "ATTENDING_IN_PERSON",
                          "ATTENDING_VIRTUAL"
                        ]
                      }
                    }
                  }
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
              },
              {
                "alias": "waitingCount",
                "args": [
                  (v29/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventTicketingTiersConnection",
                "kind": "LinkedField",
                "name": "eventTicketingTiers",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendee",
                "kind": "LinkedField",
                "name": "myAttendance",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendeeTicketPurchase",
                    "kind": "LinkedField",
                    "name": "ticketPurchase",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stripePaymentIntentStatus",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GuildMembership",
                        "kind": "LinkedField",
                        "name": "myMembership",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v30/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sponsorshipDisplay",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v12/*: any*/),
                      (v4/*: any*/)
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  (v21/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v16/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v7/*: any*/),
                      (v4/*: any*/),
                      (v17/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ],
                    "type": "User",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Form",
                "kind": "LinkedField",
                "name": "attendeeForm",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": "eventItemPresentations",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      "CREATED_AT_ASC",
                      "ID_ASC"
                    ]
                  }
                ],
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v4/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "transform",
                                "value": {
                                  "dpr": 3,
                                  "fo": "auto",
                                  "h": 24,
                                  "w": 24
                                }
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "guestPresenterAvatarUrl",
                            "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":24,\"w\":24})"
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "presentations(orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
              },
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "seoVenue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v5/*: any*/),
                      (v40/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Venue",
                "kind": "LinkedField",
                "name": "venue",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entryInstructions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine2",
                        "storageKey": null
                      },
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedAddress",
                        "storageKey": null
                      },
                      (v40/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresentationsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Presentation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v31/*: any*/),
                          (v35/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "transform",
                                "value": {
                                  "dpr": 3,
                                  "fo": "auto",
                                  "h": 48,
                                  "w": 48
                                }
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "guestPresenterAvatarUrl",
                            "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":48,\"w\":48})"
                          },
                          (v34/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v27/*: any*/),
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
              },
              {
                "alias": null,
                "args": [
                  (v22/*: any*/)
                ],
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendees",
                "plural": false,
                "selections": (v28/*: any*/),
                "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attendeeLimit",
                "storageKey": null
              },
              {
                "alias": "inPersonAttendees",
                "args": (v42/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v43/*: any*/),
                "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_IN_PERSON\"},first:10)"
              },
              {
                "alias": "inPersonAttendees",
                "args": (v42/*: any*/),
                "filters": (v44/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendeesDialogInPersonAttendees_event_inPersonAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              },
              {
                "alias": "waitingAttendees",
                "args": (v45/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v43/*: any*/),
                "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:10)"
              },
              {
                "alias": "waitingAttendees",
                "args": (v45/*: any*/),
                "filters": [
                  "filter"
                ],
                "handle": "connection",
                "key": "EventScreenAttendeesDialogWaitingAttendees_event_waitingAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              },
              {
                "alias": "onlineAttendees",
                "args": (v46/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v43/*: any*/),
                "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"ATTENDING_VIRTUAL\"},first:10)"
              },
              {
                "alias": "onlineAttendees",
                "args": (v46/*: any*/),
                "filters": (v44/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendeesDialogOnlineAttendees_event_onlineAttendees",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              },
              {
                "alias": "notAttending",
                "args": (v47/*: any*/),
                "concreteType": "EventAttendeesConnection",
                "kind": "LinkedField",
                "name": "eventAttendeesByRelevance",
                "plural": false,
                "selections": (v43/*: any*/),
                "storageKey": "eventAttendeesByRelevance(condition:{\"status\":\"NOT_ATTENDING\"},first:10)"
              },
              {
                "alias": "notAttending",
                "args": (v47/*: any*/),
                "filters": (v44/*: any*/),
                "handle": "connection",
                "key": "EventScreenAttendeesDialogNotAttending_event_notAttending",
                "kind": "LinkedHandle",
                "name": "eventAttendeesByRelevance"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5bdfe259f652ed9a7817ff35a6a983c26b71153be1b028a4a17c1bf9739056a8",
    "metadata": {},
    "name": "EventAttendButtonSingleRemoveAttendanceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5bb26eeabe29b79dd65e413c53a96a14";

export default node;
